import { render, staticRenderFns } from "./PcButtonArea.vue?vue&type=template&id=dbfdf970&"
import script from "./PcButtonArea.vue?vue&type=script&lang=ts&"
export * from "./PcButtonArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports